import MainLayout from '../components/Layouts/MainLayout';

function Documents() {


  return (
    <MainLayout>
      <div className="p-4 md:ml-64 pt-20 bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-300">
        <div className="max-w-4xl mx-auto">
          {/* Header Section */}
          <div className="mb-6">
            <div className="flex flex-wrap items-center justify-between gap-4">
              <div>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Project Documentation</h1>
                <p className="text-gray-600 dark:text-gray-400">
                  View or download the complete project specifications
                </p>
              </div>

            </div>
          </div>
          
          {/* Additional info card */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden mb-8">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
              <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">Document Information</h2>
            </div>
            
            <div className="p-6 space-y-4">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-100 dark:bg-cyan-900 flex items-center justify-center">
                  <svg className="w-4 h-4 text-cyan-600 dark:text-cyan-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <div>
                  <h3 className="font-medium text-gray-800 dark:text-gray-200">Accessibility Note</h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm mt-1">
                    This document is hosted on Google Docs. If you experience any issues viewing it in the iframe, you can use the "Open in New Tab" button above.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-100 dark:bg-emerald-900 flex items-center justify-center">
                  <svg className="w-4 h-4 text-emerald-600 dark:text-emerald-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path>
                  </svg>
                </div>
                <div>
                  <h3 className="font-medium text-gray-800 dark:text-gray-200">Offline Reading</h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm mt-1">
                    For offline reading, click the "Download PDF" button to save a copy to your device. The PDF version maintains all formatting and graphics.
                  </p>
                </div>
              </div>
              
              <div className="mt-4 p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700">
                <div className="flex items-center text-amber-600 dark:text-amber-400 mb-2">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                  </svg>
                  <span className="font-medium">Pro Tip</span>
                </div>
                <p className="text-gray-600 dark:text-gray-400 text-sm">
                  This document is periodically updated with new information. Check back regularly or bookmark this page to stay informed about the latest changes to the project.
                </p>
              </div>
            </div>
          </div>
          
          {/* Document Card */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden mb-8">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-cyan-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 flex justify-between items-center">
              <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200 flex items-center">
                <svg className="w-5 h-5 mr-2 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                </svg>
                Google Smile Project Document
              </h2>
              
              <div className="flex space-x-2">
                {/* Download button */}
                <a
                  href="https://docs.google.com/document/d/1ScG51MF4S5ltqiOAJ5RzPnM8PVNGpaQiypozSsWcFZw/export?format=pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-3 py-1.5 text-sm rounded-md bg-gradient-to-r from-cyan-500 to-emerald-500 text-white hover:from-cyan-600 hover:to-emerald-600 transition-all shadow-sm"
                >
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                  </svg>
                  Download PDF
                </a>
                
                {/* Open in new tab button */}
                <a
                  href="https://docs.google.com/document/d/1ScG51MF4S5ltqiOAJ5RzPnM8PVNGpaQiypozSsWcFZw/edit?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-3 py-1.5 text-sm rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-all"
                >
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                  </svg>
                  Open in New Tab
                </a>
              </div>
            </div>
            
            <div className="relative">
              {/* Loading overlay */}
              <div className="absolute inset-0 bg-gray-100 dark:bg-gray-800 flex items-center justify-center z-10" id="loading-overlay">
                <div className="flex flex-col items-center">
                  <svg className="animate-spin h-10 w-10 text-cyan-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <p className="text-gray-600 dark:text-gray-400">Loading document...</p>
                </div>
              </div>
              
              {/* Iframe container with custom scrollbar */}
              <div className="h-[calc(100vh-240px)] overflow-hidden">
                <iframe
                  title="Google Smile Project Document"
                  src="https://docs.google.com/document/d/1ScG51MF4S5ltqiOAJ5RzPnM8PVNGpaQiypozSsWcFZw/edit?usp=sharing"
                  className="w-full h-full border-none"
                  allowFullScreen
                  onLoad={() => {
                    // Hide loading overlay when iframe loads
                    document.getElementById('loading-overlay').style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default Documents;